import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { imageBoxShadow } from 'constants/colors';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 32px 0;
  background-color: transparent;

  ${mediaQueries.mobileOnly} {
    flex-direction: column;
    margin: 28px 0;
  }
`;

export const Image = styled.div<{ url: string }>`
  flex: 2;
  border-radius: 20px;
  max-width: 778px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  aspect-ratio: 16 / 9;
  margin: 0px 12px;
  ${props => (props.url ? `background-image: url(${props.url});` : ``)}
  ${imageBoxShadow}

  ${mediaQueries.mobileOnly} {
    height: 210px;
    max-width: 100%;
    margin: 0px;
    flex: none;
  }
`;

export const Description = styled.div<{
  backgroundColor?: string;
  withPadding?: boolean;
}>`
  flex: 1;
  max-width: 390px;
  border-radius: 20px;
  margin: 0px 12px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'transparent'};
  padding: ${({ withPadding = true }) => (withPadding ? '24px' : '0')};
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQueries.mobileOnly} {
    max-width: 100%;
    margin: 0px;
    margin-top: 32px;
    flex: none;
  }
`;
